import React, { useState, useEffect, useCallback } from "react";
import {
  Page,
  Card,
  FormLayout,
  Select,
  TextField,
  InlineError,
  Toast,
  PageActions,
  Text,
  ButtonGroup,
  Button,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useParams, useNavigate } from "react-router-dom";
import ReactSelect from "react-select";
import AsyncSelect from "react-select/async";
import { ExportMinor } from "@shopify/polaris-icons";
export default function AddEditGiftRule({ mode }) {
  const navigate = useNavigate();
  const { id } = useParams();

  const [isSaving, setIsSaving] = useState(false);

  const [rule, setRule] = useState({
    name: "",
    rule_type: "",
    rule_sub_type: "",
    product_handle: "",
    tag_value: "",
    vendor_value: "",
    card_value: "all",
    qty_or_price: "",
    min: "",
    max: "",
    discount_value: "",
    key_value: "",
    product_id: "",
  });

  const [ruleErrors, setRuleErrors] = useState({});
  const [productOptions, setProductOptions] = useState([]);

  const [activeToast, setActiveToast] = useState(false);
  const toggleToast = () => setActiveToast((t) => !t);

  const validate = () => {
    let hasError = false;
    const e = {};

    if (!rule.name.trim()) {
      e.name = "Required";
      hasError = true;
    }

    if (!rule.rule_type) {
      e.rule_type = "Required";
      hasError = true;
    }

    // GWP — ONLY subtype + key
    if (rule.rule_type === "gwp") {
      if (!rule.rule_sub_type) {
        e.rule_sub_type = "Required";
        hasError = true;
      }
      if (!rule.key_value) {
        e.key_value = "Required";
        hasError = true;
      }
      setRuleErrors(e);
      return !hasError;
    }

    // Gift OR Discount validation
    if (rule.rule_type === "gift" && !rule.product_handle) {
      e.product_handle = "Required";
      hasError = true;
    }

    if (rule.rule_type === "card_discount" && !rule.discount_value) {
      e.discount_value = "Required";
      hasError = true;
    }

    if (!rule.rule_sub_type) {
      e.rule_sub_type = "Required";
      hasError = true;
    }

    if (!rule.key_value) {
      e.key_value = "Required";
      hasError = true;
    }

    if (!rule.qty_or_price) {
      e.qty_or_price = "Required";
      hasError = true;
    }

    if (!rule.min) {
      e.min = "Required";
      hasError = true;
    }

    setRuleErrors(e);
    return !hasError;
  };

  useEffect(() => {
    // axios.get("/shopify-products").then((res) => {
    //   setProductOptions(
    //     res.data?.data?.map((p) => ({
    //       label: p.title,
    //       value: p.handle,
    //     })) || []
    //   );
    // });

    if (mode === "edit") {
      axios.get(`/gift-rules/${id}`).then((res) => {
        const r = res.data.data;
        setRule({
          name: r.name || "",
          rule_type: r.effect_type || "",
          rule_sub_type: r.rule_type || "",
          product_handle: r.product_title || r.product_handle || "",
          product_id: r.product_id || "",
          qty_or_price: r.condition || "",
          min: r.min_value ? String(r.min_value) : "",
          max: r.max_value ? String(r.max_value) : "",
          discount_value: r.discount || "",
          key_value: r.key || "",
        });
      });
    }
  }, []);

  const handleSave = () => {
    if (!validate()) return;

    setIsSaving(true);
    const formData = new FormData();

    if (mode === "edit") formData.append("_method", "PATCH");

    formData.append("name", rule.name);
    formData.append("effect_type", rule.rule_type);
    formData.append("rule_type", rule.rule_sub_type);
    formData.append("product_handle", rule.product_id);
    // formData.append("card_value", rule.card_value);
    // formData.append("tag_value", rule.tag_value);
    // formData.append("vendor_value", rule.vendor_value);
    formData.append("condition", rule.qty_or_price);
    formData.append("min_value", rule.min);
    if (rule.max) formData.append("max_value", rule.max);
    formData.append("discount", rule.discount_value);
    formData.append("key", rule.key_value);

    const url = mode === "new" ? "/gift-rules" : `/gift-rules/${id}`;

    axios
      .post(url, formData)
      .then(() => {
        if (mode === "new") navigate("/admin/settings/gift-rules");
        else toggleToast();
      })
      .finally(() => setIsSaving(false));
  };

  const selectStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 99999,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 99999,
    }),
  };
  const loadOptionsProducts = async (inputValue) => {
    if (!inputValue || inputValue.trim() === "") return [];

    const res = await axios.get(`/shopify-products?search=${inputValue}`);

    return res.data.data.map((p) => ({
      label: p.title,
      value: p.id, // ID instead of handle
      handle: p.handle, // keep handle if you still want to display it
    }));
  };
  const [isExporting, setIsExporting] = useState(false);
  const [activeExport, setActiveExport] = useState(false);
  const toggleActiveToast = useCallback(
    () => setActiveExport((activeExport) => !activeExport),
    []
  );
  const toastMarkup = activeExport ? (
    <Toast
      content={"JSON exported successfully"}
      onDismiss={toggleActiveToast}
    />
  ) : null;
  const handleExport = () => {
    setIsExporting(true);

    const bodyObj = {
      entity_type: "gift_rule_data",
    };

    axios
      .post(`/s3/save-file`, bodyObj)
      .then((result) => {
        setIsExporting(false);
        // setToastMessage("JSON exported successfully");
        toggleActiveToast();
      })

      .catch(function (error) {});
  };

  return (
    <Page
      title={mode === "new" ? "Add Gift Rule" : "Edit Gift Rule"}
      breadcrumbs={[{ onAction: () => navigate("/admin/settings/gift-rules") }]}
      // primaryAction={
      //   <ButtonGroup>
      //     <Button
      //       outline
      //       onClick={handleExport}
      //       loading={isExporting}
      //       icon={ExportMinor}
      //     >
      //       Export
      //     </Button>
      //   </ButtonGroup>
      // }
    >
      <Card sectioned>
        <FormLayout>
          {/* NAME */}
          <TextField
            label="Name"
            value={rule.name}
            onChange={(v) => setRule({ ...rule, name: v })}
            error={ruleErrors.name}
          />

          {/* RULE TYPE */}
          <Select
            label="Rule Type"
            placeholder="Select Type"
            options={[
              { label: "Gift", value: "gift" },
              { label: "GWP", value: "gwp" },
              { label: "Discount", value: "card_discount" },
            ]}
            value={rule.rule_type}
            onChange={(v) =>
              setRule({
                ...rule,
                rule_type: v,
                rule_sub_type: "",
                key_value: "",
              })
            }
            error={ruleErrors.rule_type}
          />
          <div style={{ height: "0.5rem" }}></div>

          {/* NOTHING BELOW UNTIL RULE TYPE IS SELECTED */}
          {!rule.rule_type && <></>}

          {/* ===============  GWP ONLY  =================*/}
          {rule.rule_type === "gwp" && (
            <div>
              <FormLayout>
                <Select
                  label="Sub Type"
                  placeholder="Select Sub Type"
                  options={[
                    { label: "Tag", value: "tag" },
                    { label: "Card", value: "cart" },
                    { label: "Vendor", value: "vendor" },
                  ]}
                  value={rule.rule_sub_type}
                  onChange={(v) =>
                    setRule({
                      ...rule,
                      rule_sub_type: v,
                      key_value: v === "cart" ? "all" : "",
                    })
                  }
                  error={ruleErrors.rule_sub_type}
                />

                <TextField
                  label="Key"
                  placeholder="Enter key"
                  value={rule.key_value}
                  disabled={rule.rule_sub_type === "cart"}
                  onChange={(v) => setRule({ ...rule, key_value: v })}
                  error={ruleErrors.key_value}
                />
              </FormLayout>
            </div>
          )}

          {/* ===============  GIFT + DISCOUNT  ===============*/}
          {rule.rule_type !== "" && rule.rule_type !== "gwp" && (
            <div>
              <FormLayout>
                {/* PRODUCT HANDLE (Gift Only) */}
                {rule.rule_type === "gift" && (
                  <div>
                    <Text>Product Handle</Text>
                    <AsyncSelect
                      cacheOptions
                      defaultOptions
                      loadOptions={loadOptionsProducts}
                      placeholder="Search products..."
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 99999 }),
                      }}
                      value={
                        rule.product_id
                          ? {
                              label: rule.product_handle, // show product title
                              value: rule.product_id, // must match id
                            }
                          : null
                      }
                      onChange={(v) =>
                        setRule({
                          ...rule,
                          product_id: v?.value || "", // backend ID
                          product_handle: v?.label || "", // TITLE to show in select
                        })
                      }
                    />

                    {ruleErrors.product_handle && (
                      <InlineError message={ruleErrors.product_handle} />
                    )}
                  </div>
                )}

                {/* DISCOUNT VALUE */}
                {rule.rule_type === "card_discount" && (
                  <TextField
                    label="Discount Value"
                    value={rule.discount_value}
                    onChange={(v) => setRule({ ...rule, discount_value: v })}
                    error={ruleErrors.discount_value}
                    type="number"
                  />
                )}

                {/* SUB TYPE */}
                <Select
                  label="Sub Type"
                  placeholder="Select Sub Type"
                  options={[
                    { label: "Tag", value: "tag" },
                    { label: "Card", value: "cart" },
                    { label: "Vendor", value: "vendor" },
                  ]}
                  value={rule.rule_sub_type}
                  onChange={(v) =>
                    setRule({
                      ...rule,
                      rule_sub_type: v,
                      key_value: v === "cart" ? "all" : "",
                    })
                  }
                  error={ruleErrors.rule_sub_type}
                />

                {/* KEY */}
                {rule.rule_sub_type && (
                  <TextField
                    label="Key"
                    placeholder="Enter key"
                    value={rule.key_value}
                    disabled={rule.rule_sub_type === "cart"}
                    onChange={(v) => setRule({ ...rule, key_value: v })}
                    error={ruleErrors.key_value}
                  />
                )}

                {/* QTY / PRICE */}
                <Select
                  label="Quantity / Price"
                  placeholder="Select option"
                  options={[
                    { label: "Quantity", value: "quantity" },
                    { label: "Price", value: "price" },
                  ]}
                  value={rule.qty_or_price}
                  onChange={(v) => setRule({ ...rule, qty_or_price: v })}
                  error={ruleErrors.qty_or_price}
                />

                <TextField
                  label="Minimum"
                  type="number"
                  value={rule.min}
                  onChange={(v) => setRule({ ...rule, min: v })}
                  error={ruleErrors.min}
                />

                <TextField
                  label="Maximum (optional)"
                  type="number"
                  value={rule.max}
                  onChange={(v) => setRule({ ...rule, max: v })}
                />
              </FormLayout>
            </div>
          )}
        </FormLayout>
      </Card>

      <PageActions
        primaryAction={{
          content: "Save",
          onAction: handleSave,
          loading: isSaving,
        }}
        secondaryActions={
          mode === "edit" && [
            {
              content: "Delete",
              destructive: true,
              loading: isSaving && true,
              onClick: () => {
                setIsSaving(true);
                axios
                  .delete(`/gift-rules/${id}`)
                  .then((result) => {
                    navigate(`/admin/settings/gift-rules`);
                  })
                  .catch((err) => console.log(err));
              },
            },
          ]
        }
      />

      {activeToast && <Toast content="Saved" onDismiss={toggleToast} />}
      {toastMarkup}
    </Page>
  );
}
